module.exports = __webpack_public_path__ + "img/b4c88e78-6c88-4db5-9ea2-a6041609a380.ea9087d1.webp";